'use strict';

var variables = require('./variables-1eb6495a.js');
require('./index-c6190cd6.js');

var tickUrl = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%228px%22%20height%3D%227px%22%20viewBox%3D%220%200%208%207%22%20%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%20aria-labelledby%3D%22Tick%22%3E%20%20%20%20%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cg%20id%3D%22ExportIcons%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Artboard%22%20transform%3D%22translate%280.000000%2C%20-1.000000%29%22%20%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M7.51662484%2C1.29325%20C7.12545778%2C0.90225%206.49218732%2C0.90225%206.10202068%2C1.29325%20L2.73658335%2C4.65725%20L1.90722914%2C3.82925%20C1.5170625%2C3.43825%200.883792042%2C3.43825%200.492624979%2C3.82925%20C0.102458344%2C4.21925%200.102458344%2C4.85225%200.492624979%2C5.24325%20L2.02928127%2C6.77825%20C2.4194479%2C7.16925%203.05271836%2C7.16925%203.44388542%2C6.77825%20L7.51662484%2C2.70725%20C7.9077919%2C2.31725%207.9077919%2C1.68425%207.51662484%2C1.29325%22%20id%3D%22Tick%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

const light = {
    root: {
        height: "48px",
        "&$selected": {
            backgroundColor: "unset",
            "&:not($disabled)": {
                "&::after": {
                    content: `url('${tickUrl}')`,
                    fontFamily: "LUI icons",
                    position: "absolute",
                    fontSize: "10px",
                    right: "10px",
                    color: variables.COLORS.RED,
                },
            },
        },
    },
    gutters: {
        paddingLeft: "12px",
        paddingRight: "12px",
    },
    button: {
        "&:hover": {
            backgroundColor: variables.COLORS.GREYSCALE_0_03,
        },
        "&:active": {
            backgroundColor: variables.COLORS.GREYSCALE_0_05,
        },
    },
};

var MuiListItem = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiListItem = MuiListItem;
exports.light = light;
